import React from 'react';

interface ProfileHeaderProps {
  profile: {
    name: string;
    surnames: string;
    title: string;
    avatar: {
      link: string;
      alt: string;
    };
    location: {
      municipality: string;
    };
  };
  relevantLinks: Array<{
    type: string;
    URL: string;
  }>;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ profile, relevantLinks }) => {
  // Función para extraer username de URLs
  const extractUsername = (url: string, type: string) => {
    if (type === 'linkedin') {
      const match = url.match(/linkedin\.com\/in\/([^/]+)/);
      return match ? match[1] : url;
    } else if (type === 'github') {
      const match = url.match(/github\.com\/([^/]+)/);
      return match ? match[1] : url;
    }
    return url;
  };

  return (
    <header className="cv-header">
      <div className="header-two-column">
        <div className="header-left">
          <div className="profile-image">
            <img 
              src={profile.avatar.link} 
              alt={profile.avatar.alt}
              className="avatar"
            />
          </div>
        </div>
        <div className="header-right">
          <div className="profile-info">
            <h1 className="name">{profile.name} {profile.surnames}</h1>
            {/* <h2 className="title">{profile.title}</h2> */}
            
            {/* Información de contacto */}
            <div className="contact-info">
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <span className="contact-text">alberto.msn@gmail.com</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                <span className="contact-text">+34 628 88 20 93</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
                <span className="contact-text">{profile.location.municipality}</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-9H19v2h-1.5v2H21v-2c0-1.1-.9-2-2-2zm-14 2v2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-1.5V4H19V2h-1.5C16.4 2 15.5 2.9 15.5 4v2H8.5V4C8.5 2.9 7.6 2 6.5 2H5v2h1.5z"/>
                </svg>
                <span className="contact-text">02/10/1986</span>
              </div>
            </div>

            {/* Enlaces sociales unificados */}
            <div className="contact-info">
              {relevantLinks.map((link: any, index: number) => (
                <div key={index} className="contact-item">
                  {link.type === 'linkedin' ? (
                    <>
                      <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                      <a href={link.URL} target="_blank" rel="noopener noreferrer" className="contact-text contact-link">
                        {extractUsername(link.URL, link.type)}
                      </a>
                    </>
                  ) : link.type === 'github' ? (
                    <>
                      <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                      </svg>
                      <a href={link.URL} target="_blank" rel="noopener noreferrer" className="contact-text contact-link">
                        {extractUsername(link.URL, link.type)}
                      </a>
                    </>
                  ) : (
                    <>
                      <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"/>
                      </svg>
                      <a href={link.URL} target="_blank" rel="noopener noreferrer" className="contact-text contact-link">
                        {extractUsername(link.URL, link.type)}
                      </a>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ProfileHeader;